import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
const NoteView = ({selectedCard ,notes,dataLoading ,closeModal}) => {
  return (
    <div className="fixed z-10 inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center">
    <div className="bg-white z-0  rounded-lg shadow-lg lg:w-[80%] w-[95%] max-w-full max-h-[90vh] ">
      <div className='bg-[#E179541A]'>

      <div className="flex justify-between items-center align-center p-4 ">
        <div className='flex gap-4'>
         <div className="flex ml-2">
            <p>Patient ID : </p>
            <p className='font-semibold'>{selectedCard?.patientid}</p>
          </div>
          <div className="flex mr-2">
            <p>Name : </p>
            <p className='font-semibold'>{`${selectedCard?.firstname} ${selectedCard?.lastname}`}</p>
          </div>       
        </div>   
           <div
          onClick={closeModal}
          className="cursor-pointer text-xl text-gray-700"
        >
                  <CloseIcon style={{ width: '34px', height: '34px', color: '#C7C7CB' }} />

        </div>
      </div>
      <hr/>
      </div>
        {/* Table with overflow-y-auto for scrolling */}
        <div className="max-h-[400px] overflow-y-auto rounded-xl pb-10"> {/* Add max-height and overflow here */}
          <table className="min-w-full table-auto border-collapse rounded">
            <thead>
              <tr className='bg-gray-50'>
                <th className="px-4 py-2 border-b text-[#374151] text-center">Type</th>
                <th className="px-4 py-2 border-b text-[#374151] text-center">Notes</th>
                <th className="px-4 py-2 border-b text-[#374151] text-center">Datetime</th>
                <th className="px-4 py-2 border-b text-[#374151] text-center">User</th>
              </tr>
            </thead>
            <tbody className='overflow-y-auto'>
              {dataLoading ? (
                <tr>
                  <td colSpan="4" className="px-2 py-1 text-center">
                    <div className="flex justify-center items-center">
                      <div className="w-6 h-6 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
                    </div>
                    Loading...
                  </td>
                </tr>
              ) : notes.length > 0 ? (
                notes.map((note, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    {/* Type */}
                    <td className="px-2 py-1 border-b">{note.category}</td>

                    {/* Notes */}
                    <td className="px-2 py-1 border-b">
                      {note.notes.replace(/<[^>]+>/g, '')}
                    </td>

                    {/* Datetime */}
                    <td className="px-2 py-1 border-b">{note.created_at}</td>

                    {/* User */}
                    <td className="px-2 py-1 border-b">{note.created_by}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="px-2 py-1 text-center">
                    No notes available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
     
    </div>
  </div>
  )
}

export default NoteView